import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { SeatMapComponent } from './seat-map.component';
import { SeatModule } from '../seat/seat.module';
import { InputSubmitModule } from '../input-submit/input-submit.module';
import { CheckBoxModule } from '../checkbox/checkbox.module';
import { PipesModule } from 'src/app/core/pipes/pipes.module';

@NgModule({
  declarations: [SeatMapComponent],
  imports: [
    CommonModule,
    SharedModule,
    SeatModule,
    ReactiveFormsModule,
    InputSubmitModule,
    CheckBoxModule,
    PipesModule
  ],
  exports: [SeatMapComponent],
})
export class SeatMapModule {}
